import { Button } from '@/components/ui/button';
import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/components/ui/form';
import type { Control, UseFormSetValue } from 'react-hook-form';
import type { BulkFormValues } from '../zod/bulk-form-schema';
import { daySelectionPresets } from '../zod/bulk-form-schema';

const weekDays = [
	{ key: 'sunday', label: 'S', title: 'Sunday' },
	{ key: 'monday', label: 'M', title: 'Monday' },
	{ key: 'tuesday', label: 'T', title: 'Tuesday' },
	{ key: 'wednesday', label: 'W', title: 'Wednesday' },
	{ key: 'thursday', label: 'T', title: 'Thursday' },
	{ key: 'friday', label: 'F', title: 'Friday' },
	{ key: 'saturday', label: 'S', title: 'Saturday' },
];

interface DaysOfWeekSelectorProps {
	control: Control<BulkFormValues>;
	setValue: UseFormSetValue<BulkFormValues>;
}

export function DaysOfWeekSelector({
	control,
	setValue,
}: DaysOfWeekSelectorProps) {
	return (
		<div className='tw-space-y-3'>
			<FormLabel>Days of Week</FormLabel>

			{/* Preset Buttons */}
			<div className='tw-flex tw-flex-wrap tw-gap-2'>
				<Button
					type='button'
					variant='outline'
					size='sm'
					onClick={() => setValue('daysOfWeek', daySelectionPresets.all)}
				>
					Select All
				</Button>
				<Button
					type='button'
					variant='outline'
					size='sm'
					onClick={() => setValue('daysOfWeek', daySelectionPresets.none)}
				>
					Deselect All
				</Button>
				<Button
					type='button'
					variant='outline'
					size='sm'
					onClick={() => setValue('daysOfWeek', daySelectionPresets.weekdays)}
				>
					Weekdays Only (S-T)
				</Button>
				<Button
					type='button'
					variant='outline'
					size='sm'
					onClick={() => setValue('daysOfWeek', daySelectionPresets.weekends)}
				>
					Weekends Only (F-S)
				</Button>
			</div>

			{/* Individual Day Toggles */}
			<div className='tw-flex tw-gap-1'>
				{weekDays.map(({ key, label, title }) => (
					<FormField
						key={key}
						control={control}
						name={`daysOfWeek.${key}` as keyof BulkFormValues}
						render={({ field }) => (
							<FormItem>
								<FormControl>
									<Button
										type='button'
										variant={field.value ? 'default' : 'outline'}
										size='sm'
										title={title}
										className='tw-w-8 tw-h-8 tw-p-0 tw-text-xs'
										onClick={() => field.onChange(!field.value)}
									>
										{label}
									</Button>
								</FormControl>
							</FormItem>
						)}
					/>
				))}
			</div>

			<FormDescription>
				Select which days of the week to include in the bulk creation
			</FormDescription>
			<FormMessage />
		</div>
	);
}
